import * as Yup from "yup";
export const initialValues = (data) => {
  console.log(data, "details");
  const typeMap = {
    products: 1,
    stores: 2,
    categories: 3,
    occasions: 4,
    tags: 5,
  };
  return {
    ...data,
    featuredAdEn: data?.localized_data?.en?.banner,
    featuredAdAr: data?.localized_data?.ar?.banner,
    data: typeMap[data?.data] || "",
  };
};

export const structure = (_, isClickable, t, formik, options) => {
  const dataType = formik?.values?.data;
  let resolvedOptions = options?.[dataType]?.options || [];
  const currentId = formik?.values?.data_id;
  if (currentId && !resolvedOptions.some((opt) => opt.id === currentId)) {
    resolvedOptions = [
      // { id: currentId, name: `${t("common.id")}: ${currentId}` },
      ...resolvedOptions,
    ];
  }

  return [
    {
      head: "",
      width: "100%",
      list: [
        {
          name: `featuredAdEn`,
          kind: "upload",
          type: "image",
          label: `${t("featured_ads.upload_featured_ad_en")}*`,
          placeholder: t("featured_ads.upload_placeholder"),
          text: t("featured_ads.file_size_limit"),
          width: "47%",
          enableVideo: true,
        },
        {
          name: `featuredAdAr`,
          kind: "upload",
          type: "image",
          label: `${t("featured_ads.upload_featured_ad_ar")}*`,
          placeholder: t("featured_ads.upload_placeholder"),
          text: t("featured_ads.file_size_limit"),
          width: "47%",
        },
        {
          name: `need_action`,
          kind: "checkbox",
          type: "text",
          label: t("featured_ads.is_clickable"),
          width: "12%",
          placeholder: "",
        },
        {
          name: `is_visible`,
          kind: "checkbox",
          type: "text",
          label: t("featured_ads.is_visible"),
          width: "70%",
          value: "checked",
          placeholder: "",
        },
        isClickable && {
          name: `data`,
          kind: "radioBox",
          label: t("featured_ads.data"),
          width: "100%",
          options: [
            { label: t("featured_ads.products"), value: 1 },
            { label: t("featured_ads.stores"), value: 2 },
            { label: t("featured_ads.categories"), value: 3 },
            { label: t("featured_ads.occasions"), value: 4 },
            { label: t("featured_ads.tags"), value: 5 },
          ],
        },
        isClickable &&
          dataType && {
            name: `data_id`,
            kind: "multiSelect",
            label: t("featured_ads.data_id"),
            width: "50%",
            placeholder: t("featured_ads.data_id"),
            isMulti: false,
            ...options?.[dataType],
            options: resolvedOptions,
          },
      ],
    },
  ];
};

export const validationSchema = () =>
  Yup.object().shape({
    featuredAdEn: Yup.string().required("required"),
    featuredAdAr: Yup.string().required("required"),
    is_visible: Yup.boolean(),
    need_action: Yup.boolean(),
  });
